import { STATIC_QR_DETAILS } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  staticqrDetailsStatus: undefined,
  staticqrDetailsError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STATIC_QR_DETAILS.FETCH:
      return {
        ...state,
        staticqrDetailsStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case STATIC_QR_DETAILS.SUCCESS:
      return {
        ...state,
        ...action.payload,
        staticqrDetailsStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case STATIC_QR_DETAILS.FAILED:
      return {
        ...state,
        staticqrDetailsError: action.payload,
        staticqrDetailsStatus: CONSTANTS.API_STATUS.FAILED,
      };
    default:
      return state;
  }
};
